import { WorkspaceRoleSchema } from "../../workspace";
import { DesignSystemRole } from "./ds-role";
import { DesignSystemInvitation } from "./invitations";
import { z } from "zod";
export const DesignSystemMembership = z.object({
    id: z.string(),
    userId: z.string(),
    designSystemId: z.string(),
    designSystemRole: DesignSystemRole.optional(),
    workspaceMembershipId: z.string(),
    workspaceRole: WorkspaceRoleSchema,
    isDeactivated: z.boolean(),
});
export const DesignSystemMembers = z.object({
    members: DesignSystemMembership.array(),
    invitations: DesignSystemInvitation.array(),
});
export const DesignSystemPendingMemberInvitation = z.object({
    inviteId: z.string(),
    /**
     * Role that the user will have in the design system, undefined
     * if it should be inherited from the workspace
     */
    designSystemRole: DesignSystemRole.optional(),
});
export const DesignSystemUserInvitation = z.object({
    userId: z.string(),
    /**
     * Role that the user will have in the design system, undefined
     * if it should be inherited from the workspace
     */
    designSystemRole: DesignSystemRole.optional(),
});
export const DesignSystemInvite = z.object({
    email: z.string(),
    workspaceRole: WorkspaceRoleSchema,
    /**
     * Role that the user will have in the design system, undefined
     * if it should be inherited from the workspace
     */
    designSystemRole: DesignSystemRole.optional(),
});
export const DesignSystemMemberUpdate = z.object({
    userId: z.string(),
    designSystemRole: DesignSystemRole.nullable(),
});
export const DesignSystemInviteUpdate = z.object({
    /**
     * Workspace invitation id
     */
    inviteId: z.string(),
    designSystemRole: DesignSystemRole.nullable(),
});
export const DesignSystemMembershipUpdates = z.object({
    usersToInvite: DesignSystemUserInvitation.array().optional(),
    invitesToInvite: DesignSystemPendingMemberInvitation.array().optional(),
    emailsToInvite: DesignSystemInvite.array().optional(),
    usersToUpdate: DesignSystemMemberUpdate.array().optional(),
    invitesToUpdate: DesignSystemInviteUpdate.array().optional(),
    removeUserIds: z.string().array().optional(),
    deleteInvitationIds: z.string().array().optional(),
    isDeveloperInvite: z.boolean().optional(),
});
